export default "/images/bar-chart.svg?fb875840099913f1fb3f5b820fc60038";